import Component from "@glimmer/component";
import { fn } from "@ember/helper";
import { action } from "@ember/object";
import { service } from "@ember/service";
import DMenu from "discourse/float-kit/components/d-menu";
import { eq } from "discourse/truth-helpers";
import DButton from "discourse/ui-kit/d-button";
import DDropdownMenu from "discourse/ui-kit/d-dropdown-menu";
import dIcon from "discourse/ui-kit/helpers/d-icon";
import { i18n } from "discourse-i18n";
import { TABLE_AI_LAYOUT, TABLE_LAYOUT } from "../services/gists.js";

export default class AiGistToggle extends Component {
  @service gists;

  get buttons() {
    return [
      {
        id: TABLE_LAYOUT,
        label: "discourse_ai.summarization.topic_list_layout.button.compact",
        icon: "discourse-table",
      },
      {
        id: TABLE_AI_LAYOUT,
        label: "discourse_ai.summarization.topic_list_layout.button.expanded",
        icon: "discourse-table-sparkles",
        description:
          "discourse_ai.summarization.topic_list_layout.button.expanded_description",
      },
    ];
  }

  get selectedOptionId() {
    return this.gists.currentPreference;
  }

  get currentButton() {
    const buttonPreference = this.buttons.find(
      (button) => button.id === this.selectedOptionId
    );
    return buttonPreference || this.buttons[0];
  }

  @action
  onRegisterApi(api) {
    this.dMenu = api;
  }

  @action
  onSelect(optionId) {
    this.gists.setPreference(optionId);
    this.dMenu.close();
  }

  <template>
    {{#if this.gists.showToggle}}
      <DMenu
        @autofocus={{true}}
        @identifier="topic-list-layout"
        @modalForMobile={{true}}
        @onRegisterApi={{this.onRegisterApi}}
        @triggerClass="btn-default btn-icon"
      >
        <:trigger>
          {{dIcon this.currentButton.icon}}
        </:trigger>
        <:content>
          <DDropdownMenu as |dropdown|>
            {{#each this.buttons as |button|}}
              <dropdown.item
                class={{if (eq this.currentButton.id button.id) "--selected"}}
              >
                <DButton
                  class="btn-transparent
                    {{if button.description '--with-description'}}"
                  @action={{fn this.onSelect button.id}}
                  @icon={{button.icon}}
                  @label={{button.label}}
                >
                  {{#if button.description}}
                    <div class="btn__description">
                      {{i18n button.description}}
                    </div>
                  {{/if}}
                </DButton>
              </dropdown.item>
            {{/each}}
          </DDropdownMenu>
        </:content>
      </DMenu>
    {{/if}}
  </template>
}
